import React from 'react';
import VideoPlay from './VideoPlay';
import styled from 'styled-components';

const LessonDataVideo = ({ seed, freeze = false, onChange = () => {} }) =>
  seed ? (
    <VideoPlayStyled
      url={seed}
      onEnded={() => onChange({ ready: true, data: seed })}
    />
  ) : null;

const VideoPlayStyled = styled(VideoPlay)``;

export default LessonDataVideo;
